<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="showAddUserSidebar($event)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Adicionar novo usuário
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >

          <!-- Username -->
          <validation-provider
            #default="validationContext"
            name="Nome"
            rules="required"
          >
            <b-form-group
              label="Nome"
              label-for="username"
            >
              <b-form-input
                id="nome_usuario"
                v-model="userData.nome_cliente"
                :state="getValidationState(validationContext)"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Email -->
          <validation-provider
            #default="validationContext"
            name="Email"
            rules="required|email"
          >
            <b-form-group
              label="Login"
              label-for="login"
            >
              <b-form-input
                id="login"
                v-model="userData.login"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Senha -->
          <validation-provider
            v-if="blankUserData.id === null"
            #default="validationContext"
            name="Senha"
            rules="required|min:6"
          >
            <b-form-group
              label="Senha"
              label-for="senha_usuario"
            >
              <b-form-input
                id="senha_usuario"
                v-model="userData.senha"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- User Grupo Usuario -->
          <validation-provider
            #default="validationContext"
            name="Grupo Usuario"
            rules="required"
          >
            <b-form-group
              label="Grupo Usuario"
              label-for="id-grupo-usuario"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="userData.id_grupousuario"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="gruposOptions"
                label="grupousuario"
                :reduce="val => val.id"
                :clearable="false"
                input-id="id-grupo-usuario"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              {{ userData.id === null ? 'Adicionar' : 'Atualizar' }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>

  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { computed } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-usuarios-sidebar-active',
  },
  props: {
    blankUserData: {
      type: Object,
      required: true,
    },
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    gruposOptions: {
      type: Array,
      required: true,
    },
    planOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
    }
  },
  methods: {
    showAddUserSidebar(e) {
      this.$emit('input', e)
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const userData = computed({
      get: () => {
        if (props.blankUserData) {
          return props.blankUserData
        }
        return JSON.parse(JSON.stringify(props.blankUserData))
      },
      set: val => {
        emit('update:blankUserData', val)
      },
    })
    const resetuserData = () => {
      userData.value = JSON.parse(JSON.stringify(userData.value))
    }

    const onSubmit = () => {
      if (userData.value.id === null) {
        store.dispatch('app-adm-usuario/addUser', {
          ...userData.value,
        })
          .then(() => {
            emit('refetch-data')
            emit('input', false)
          })
          .catch(erro => {
            toast({
              component: ToastificationContent,
              props: {
                title: erro.response.data.message,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
      }

      store.dispatch('app-adm-usuario/updatedUser', {
        ...userData.value,
      })
        .then(() => {
          emit('refetch-data')
          emit('input', false)
        })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetuserData)

    return {
      userData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
